import { Group } from '@/components/_common';
import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import StatusTag from '@/components/_common/StatusTag';
import { useDisclosure } from '@/hooks';
import { truncateString } from '@/utils/functions/truncateString';
import { Button, Tooltip } from 'antd';
import { X } from 'react-feather';
import { useCustomerFormContext } from '../CustomerFormProvider';
import CustomerCategorySelectModal from './CustomerCategorySelectModal';
import { useCustomerUpdateCategory } from '@/core/domain/people/Customers/Customers.hooks';
import './style.less';

export default function CustomerCategoryTag() {
  const { customer, customerDetailsLoading } = useCustomerFormContext();
  const [modalSelectCategoryOpened, modalSelectCategoyActions] =
    useDisclosure();

  const updateCategory = useCustomerUpdateCategory();

  const category = customer?.category;

  async function handleIncludeCategory(categoryId?: number) {
    if (customer?.id) {
      await updateCategory.mutateAsync({ id: customer.id, categoryId });
    }
  }

  return (
    <div style={{ marginBottom: 10 }}>
      {!!category?.id ? (
        <Group gap={4}>
          <Tooltip title={category?.name?.toUpperCase() || ''}>
            <StatusTag
              size="lg"
              color={category?.color}
              label={truncateString(category?.name?.toUpperCase(), 20)}
              onClick={modalSelectCategoyActions.open}
            />
          </Tooltip>

          <Button
            icon={<AntdFeatherIcon icon={<X cursor="pointer" />} size={14} />}
            size="small"
            onClick={() => handleIncludeCategory(undefined)}
            loading={false}
            disabled={customerDetailsLoading}
          />
        </Group>
      ) : (
        <StatusTag
          color="default"
          size="lg"
          className="card-select-tag"
          label="Selecionar Categoria"
          onClick={modalSelectCategoyActions.open}
          disabled={false || customerDetailsLoading}
        />
      )}

      <CustomerCategorySelectModal
        onCancel={modalSelectCategoyActions.close}
        open={modalSelectCategoryOpened}
        onCallback={handleIncludeCategory}
        confirmLoading={false}
      />
    </div>
  );
}
